export const usa = {
  slug: "usa",
  name: "United States",
  flag: "🇺🇸",
  tagline: "World’s #1 for Tech, Research & High Salaries",
  heroImg: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?q=80&w=1600&auto=format&fit=crop",
  accentColor: "#1F3A93",
  students: "200+",
  avgTuition: "$20,000–$60,000/yr",
  avgLiving: "$1,200–$2,500/mo",
  workPermit: "OPT (1–3 years)",
  ieltsReq: "6.5–7.5",
  intakeMonths: ["September", "January", "May"],
  overview:
    "The USA is the global leader in higher education, innovation, and research. With STEM OPT extensions up to 3 years and the highest-paying job market, it is the top choice for ambitious students targeting global careers.",

  whyChoose: [
    { icon: "💼", title: "High-Paying Jobs", desc: "USA offers the highest average salaries globally, especially in tech, engineering, and finance." },
    { icon: "🧠", title: "Top Universities", desc: "Home to Harvard, MIT, Stanford — the world’s best institutions." },
    { icon: "🚀", title: "STEM OPT Extension", desc: "Up to 3 years work authorization after graduation." },
    { icon: "🌎", title: "Global Exposure", desc: "Work with top global companies like Google, Amazon, Microsoft." },
    { icon: "📊", title: "Flexible Education", desc: "Choose electives, minors, and interdisciplinary courses." },
    { icon: "💡", title: "Innovation Hub", desc: "Silicon Valley, Wall Street, NASA — unmatched opportunities." },
  ],

  process: [
    { step: "01", title: "University Shortlisting", desc: "We match your profile with top-ranked universities and safe admits." },
    { step: "02", title: "Applications", desc: "SOP, LORs, Resume — optimized for US standards." },
    { step: "03", title: "Visa (F1)", desc: "I-20, SEVIS, DS-160, interview prep." },
    { step: "04", title: "Pre-Departure", desc: "Housing, bank account, travel checklist." },
  ],

  universities: [
    "harvard", "mit", "stanford", "caltech", "uchicago",
    "upenn", "columbia", "yale", "princeton", "cornell",
    "ucla", "uc-berkeley", "ucsd", "usc", "nyu",
    "georgia-tech", "ut-austin", "purdue", "uiuc", "uw-seattle",
    "duke", "northwestern", "johns-hopkins", "brown", "dartmouth",
    "rice", "vanderbilt", "notre-dame", "emory", "cmu",
    "virginia-tech", "arizona-state", "rutgers", "umass-amherst",
    "university-of-florida", "penn-state", "indiana-university",
    "university-of-maryland", "colorado-boulder", "texas-am",
    "oregon-state", "washington-state", "ut-dallas",
    "sunny-buffalo", "wayne-state", "george-washington",
    "university-of-houston", "san-diego-state", "clemson", "iowa-state"
  ],

  stats: [
    { n: "200+", label: "Students Placed" },
    { n: "3yr", label: "OPT Duration" },
    { n: "95%", label: "Visa Success" },
    { n: "3", label: "Intakes/Year" },
  ],
};